import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import "./AppleLocalNav.css";

export default function AppleLocalNav({ title, overview, pages = [], action, overviewLabel = "Overview" }) {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [compact, setCompact] = useState(false);
  const rootRef = useRef(null);
  const links = [{ label: overviewLabel, to: overview }, ...pages].filter(x => x.to);
  // At most four visible direct items; additional destinations live in Browse All.
  const direct = links.slice(0, 3);
  const hasBrowse = pages.length >= 2;
  useEffect(() => { setExpanded(false); }, [location.pathname]);
  useEffect(() => {
    let lastY = window.scrollY;
    const update = () => {
      const y = window.scrollY;
      setCompact(y > 64 && y > lastY + 1);
      lastY = y;
    };
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);
  useEffect(() => {
    const key = e => { if (e.key === "Escape") setExpanded(false); };
    document.addEventListener("keydown", key);
    return () => document.removeEventListener("keydown", key);
  }, []);
  return <>{expanded && createPortal(<div className="lok-localnav-page-scrim" aria-hidden="true" onClick={() => setExpanded(false)} />, document.body)}<nav ref={rootRef} className={`lok-localnav ${expanded ? "is-open" : ""} ${compact ? "is-compact" : ""}`} aria-label={title + " section navigation"}>
    <div className="lok-localnav-bar">
      <Link className="lok-localnav-title" to={overview}>{title}</Link>
      <div className="lok-localnav-desktop-links">
        {direct.map(item => <Link key={item.to} to={item.to} className={location.pathname === item.to ? "selected" : ""}>{item.label}</Link>)}
        {hasBrowse && <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} aria-controls={"localnav-browse-" + title.replace(/\\s/g, "-")}>Browse All <span className="lok-chevron"/></button>}
      </div>
      {action && <Link className="lok-localnav-action" to={action.to}>{action.label}</Link>}
      <button type="button" className="lok-localnav-toggle" aria-label={expanded ? "Close section menu" : "Open section menu"} aria-expanded={expanded} onClick={() => setExpanded(v => !v)}><span className="lok-chevron" /></button>
    </div>
    <div className="lok-localnav-expanded" id={"localnav-browse-" + title.replace(/\\s/g, "-")} inert={!expanded ? "" : undefined}>
      <div className="lok-localnav-expanded-content">
        {links.map(item => <Link key={item.to} to={item.to} className={location.pathname === item.to ? "selected" : ""} aria-current={location.pathname === item.to ? "page" : undefined} onClick={() => setExpanded(false)}>{item.label}</Link>)}
      </div>
    </div>
  </nav></>;
}
